import feature1 from '../assets/images/resources/feature-1-1.jpg';
import feature2 from '../assets/images/resources/feature-1-2.jpg';
import feature3 from '../assets/images/resources/feature-1-3.jpg';


export const features = [
    {
        img: feature1,
        iconClass: 'icon-solution',
        title: 'labour outsourcing',
        text: 'Cost-effective solution to handle your staffing needs efficiently.',
link:'/services#labour'
    },
    {
        img: feature2,
        iconClass: 'icon-creative-idea',
        title: 'Recruitment and placement',
        text: `We identify and attract top-tier talent that aligns with your company's values and goals.`,
        link:'/services#recruitment-labour'
    },
    {
        img: feature3,
        iconClass: 'icon-mission',
        title: 'Expert HR advisory & solutions',
        text: 'Navigate the complexities of HR management with our expert advisory services',
        link:'/services#advisory-labour'
    }
];